import _ from 'lodash';
import { createSelector } from 'reselect';

const auth = (state) => state.auth;
const user = (state) => state.auth.user;

export const authenticatedSelector = createSelector(auth, (a) => a.authenticated);
export const currentUserSelector = createSelector(user, (u) => u);

export const envSelector = createSelector(auth, (a) => a.env);

export function hasPermission(user, permission) {
  return (_.get(user, 'permissions') || []).includes(permission);
}
export function hasPermissions(userPermissions = [], requiredPermissions = [], operator = 'OR') {
  const filterFunc = operator === 'OR' ? 'some' : 'every';

  return requiredPermissions?.[filterFunc]((requiredPerm) => userPermissions?.includes(requiredPerm)) ?? false;
}
